import styled from '@emotion/styled';

const Container = styled.div<{ uploading: boolean }>`
  position: relative;
  width: 100%;
  height: 120px;
  overflow: hidden;
  background-color: #fbfcfc;
  border-radius: 2px;
  border: ${({ uploading }) =>
    uploading ? '1px solid #DBAAD9' : '1px solid #e7e9ec'};
  transition: border 0.5s ease;
`;

const GradientBlob = styled.div<{
  bottom?: string;
  left?: string;
  right?: string;
  transform?: string;
  width?: string;
}>`
  position: absolute;
  width: ${({ width }) => width ?? '100%'};
  height: 180%;
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    rgba(251, 252, 252, 1) 0%,
    rgba(251, 252, 252, 1) 25%,
    rgba(251, 252, 252, 1) 50%,
    rgba(251, 252, 252, 0.15) 70%,
    rgba(251, 252, 252, 0)
  );
  filter: blur(10px);
  z-index: 1;
  bottom: ${({ bottom }) => bottom ?? 'auto'};
  left: ${({ left }) => left ?? 'auto'};
  right: ${({ right }) => right ?? 'auto'};
  transform: ${({ transform }) => transform ?? 'none'};
`;

const DotsBackground = styled.div<{ isHovered: boolean }>`
  width: 100%;
  height: 100%;
  background-image: url(/icons/dots.svg);
  background-color: #c77ac4;
  background-repeat: repeat;
  position: absolute;
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
  transition: opacity 1s ease;
`;

const ContentLayer = styled.div<{ uploading: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  text-align: center;
  background-color: ${({ uploading }) =>
    uploading ? 'rgba(255, 252, 255, 0.80)' : ''};
  backdrop-filter: ${({ uploading }) => (uploading ? 'blur(4px)' : '')};
  transition: background 0.5s ease;
`;

const StyledUploadButton = styled.button<{
  disabled?: boolean;
  uploading?: boolean;
}>`
  border-radius: 8px;
  border: 1px solid #f2dff1;
  background: #fff;
  box-shadow: 0 0 16px 0 rgba(199, 122, 196, 0.16);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: inline-flex;
  gap: 6px;
  min-width: 64px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
  color: ${({ uploading }) => (uploading ? '#F55060' : 'black')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

const UploadBoxLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

const UploadBoxSubLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #888d96;
`;

export {
  Container,
  GradientBlob,
  DotsBackground,
  ContentLayer,
  StyledUploadButton,
  UploadBoxLabel,
  UploadBoxSubLabel,
};
